import * as React from "react";
import DatePicker from "react-datepicker";
import * as moment from "moment";
import { Field } from "react-final-form";
import "./DatePicker.css";
import classNames from "classnames";

export default class DatePickerSura extends React.Component<DatePickerProps, any> {

    constructor(props: DatePickerProps) {
        super(props);
        this.state = {
            startDate: props.fechaInicial
        };
    }

    render() {
        return (
            <Field name={this.props.name}>
                {({ input, meta }) => {
                    const value = input.value ? moment(input.value, DATE_FORMAT) : this.props.fechaInicial;

                    input.value = value ? value.format(DATE_FORMAT) : undefined;
                    return (
                        <div>
                            <div className={"input-group date"}>
                                <DatePicker
                                    {...input}
                                    autoComplete="off"
                                    className={classNames("form-control", "CustomClass")}
                                    selected={value}
                                    maxDate={this.props.fechaMaxima}
                                />
                                <span className="input-group-addon cursor-auto"> <i
                                    className="glyphicon glyphicon-time" /> </span>
                            </div>
                            <span>
                                {meta.error && <span className={"text-danger"}>{meta.error}</span>}
                            </span>
                        </div>
                    );
                }}
            </Field>
        );
    }

}

interface DatePickerProps {
    fechaInicial?: moment.Moment,
    fechaMaxima?: moment.Moment,
    name: string
}

export const DATE_FORMAT = "DD/MM/YYYY";
export const DATE_FORMAT_WITH_HOUR = "DD/MM/YYYY HH:mm";


// WEBPACK FOOTER //
// ./src/co/sura/dominio/general/componentes/DatePicker.tsx